import { axiosInstance } from "../../config/axios"
import { APIURL } from "../../configApi";

const InvoicesService = {}
InvoicesService.List =   ( ) => {
      
      return  axiosInstance.get(`${APIURL}/global/invoices` )
}






export default InvoicesService;